.overlay {
  display: none;
}

@media only screen and (min-width: 768px) {
  .overlay {
    display: block;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 50%);
    z-index: var(--ns-z-index-autocomplete-overlay);
  }
}

.autocomplete {
  display: none;
}

/* There is no autocomplete on mobile, only render it from 768px up */
@media only screen and (min-width: 768px) {
  .autocomplete {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: start;
    background-color: var(--ns-color-white);
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;

    /* TODO: remove once the dropdown is positioned relative to the header in the real page layout */
    top: 90px;
    z-index: var(--ns-z-index-autocomplete);
    max-width: var(--ns-max-width-autocomplete);
    border: var(--ns-border-width-thin) solid var(--ns-color-grey-light);
    border-radius: var(--ns-border-radius-3);
    width: auto;
    font-family: var(--ns-font-family);
    font-size: var(--ns-font-size-4);
  }
}

.container {
  margin-top: auto;
  width: 100%;
}

.paddingContainer {
  padding: var(--ns-space-1);
}

.section {
  display: flex;
  flex-direction: row;
}

.items {
  display: flex;
  flex-direction: row;
}

.suggestionsColumn {
  display: flex;
  flex-direction: column;
  gap: var(--ns-space-4);
  border-right: var(--ns-border-width-thin) solid var(--ns-color-grey-light);
  min-width: 200px;
  padding: var(--ns-space-2);
}

.suggestionGroup {
  display: flex;
  flex-direction: column;
}

.suggestionHeading {
  font-size: 15px;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.productsColumn {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: var(--ns-space-1);
}

.keywords {
  display: flex;
  flex-direction: column;
}

.products {
  gap: var(--ns-space-2);
  margin-bottom: var(--ns-space-2);
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
}

.products > :nth-child(n + 9) {
  display: none;
}

.button {
  border-top-color: var(--ns-color-grey-light);
  border-top-width: var(--ns-border-width-thin);
  border-top-style: solid;
  border-radius: 0;
  display: flex;
  justify-content: center;
  padding-bottom: var(--ns-space-4);
}

.submit.submit {
  color: var(--ns-color-white);
  background-color: var(--ns-color-black);
  border-radius: 0;
  text-align: center;
  width: 100%;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 700;
}